import axios from '../../functions/axios';
import { useState, useReducer } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import style from './Clients.module.css';

function EditClient() {
  const location = useLocation();
  const navigate = useNavigate();
  const formReducer = (state, event) => {
    return {
      ...state,
      [event.name]: event.value,
    };
  };

  const [formData, setFormData] = useReducer(formReducer, {
    _id: location.state.client._id,
    companyName: location.state.client.companyName || location.state.client.name,
    phoneNumber: location.state.client.phoneNumber,
    clientData: location.state.client.clientData,
    timocomID: location.state.client.timocomID,
  });

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    await axios.patch(`/client`, formData);
    navigate(location.state.from || '/clientsList');
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  const handleDeleteClient = async (event) => {
    if (event.target.id !== 'remove') return;
    event.preventDefault();
    event.stopPropagation();
    const confirmBox = window.confirm("Czy chcesz usunąć te dane ?")
    if (confirmBox) {
    await axios.delete(`/client`, {
      data: {
        companyName: location.state.client.companyName || location.state.client.name,
      }
    });
  }
    navigate('/clientsList');
  };

  return (
    <div className={style.wrapper}>
      <form>
        <div className={style.section}>
          <h2 className={style.category}>Edycja Klienta</h2>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='companyName-data'>Nazwa klienta:</label>
            <input required={true} type='text' id='companyName-data' placeholder='Nazwa klienta' name='companyName' onChange={handleChange} value={formData?.companyName ?? location.state?.client?.companyName} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='phoneNumber-data'>Nr telefonu:</label>
            <input type="text" id='phoneNumber-data' placeholder="" name='phoneNumber' onChange={handleChange} value={formData?.phoneNumber ?? location.state?.client?.phoneNumber ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='timocom-data'>
              TIMOCOM ID:
            </label>
            <input id='timocom-data' name='timocomID' type='text' onChange={handleChange} value={formData?.timocomID ?? location.state?.client?.timocomID ?? ''} />
          </div>
          <hr />
        <div className={style.row}>
          <label className={style.subcategory} htmlFor='paletts'>Saldo palet?</label>
          <input id='paletts' type='checkbox' name='paletts' onChange={handleChange} checked={formData?.paletts ?? location.state?.client?.paletts } />
        </div>
        <hr />
          <div className={style.category}>Dane klienta</div>
          <div className={style.row}>
            <textarea className={style.textData} id='client-data' name='clientData' onChange={handleChange} value={formData?.clientData ?? location.state?.client?.clientData ?? ''} />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='isBlacklisted'>Czarna lista</label>
            <input id='isBlacklisted' type='checkbox' name='isBlacklisted' onChange={handleChange} checked={formData?.isBlacklisted ?? location.state?.client?.isBlacklisted } />
        </div>
          <hr />
          <span className={style.buttons}>
            <button id="cancel" className='btn btn-default' onClick={navigate.bind(null, location.state.from || '/clientsList')}>Anuluj</button>
            <button id="remove" className='btn btn-default' onClick={handleDeleteClient}>Usuń</button>
            <button id="submit" className='btn btn-default' onClick={handleSubmit} type='submit'>Zapisz</button>
          </span>
        </div>
      </form>
    </div>
  );
}

export default EditClient;